<div class="badge">
  <div class="body-badge" [ngClass]="typeBadge">
    <label for="text-badge">{{ textBadge }}</label>
  </div>
</div>
